import React from 'react';
import PropTypes from 'prop-types';

import { SpinnerMatchingStyled } from './SpinnerMatching.styled';

const SpinnerPath = () => (
  <svg id="path" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.72 130.72"><path d="M4.57 66.57c0-33.69 27.31-61 61-61s61 27.31 61 61" fill="none" stroke="#000" strokeWidth="5" strokeLinecap="round" strokeMiterlimit="10" strokeDasharray="117,105" /></svg>
);

const SpinnerMatching = ({ children }) => (
  <SpinnerMatchingStyled>
    <SpinnerPath />
    {children}
  </SpinnerMatchingStyled>
);

SpinnerMatching.propTypes = {
  children: PropTypes.node,
};

SpinnerMatching.defaultProps = {
  children: null,
};

export default SpinnerMatching;
